import { render, staticRenderFns } from "./optimiser-sa-fiche-google-my-business-25-conseils-pour-ameliorer-votre-classement-local.vue?vue&type=template&id=924ac618&"
import script from "./optimiser-sa-fiche-google-my-business-25-conseils-pour-ameliorer-votre-classement-local.vue?vue&type=script&lang=js&"
export * from "./optimiser-sa-fiche-google-my-business-25-conseils-pour-ameliorer-votre-classement-local.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports